import MainPageProdutividade from '@/screens/produtividade/MainPage.vue'
import { items } from '@/screens/produtividade/config.js'

const produtividade = [
  {
    path: 'produtividade',
    name: 'produtividade',
    component: MainPageProdutividade,
    redirect: { name: 'produtividade/home' },
    children: [...items]
  }
]

export default produtividade



// WEBPACK FOOTER //
// ./src/router/produtividade.js